import React, { Component } from 'react';

class ICIPAppRestrict extends Component{
    render() {
        return (<div>This website is restricted to ice-users ldap group only.</div>);
    }
}

export default ICIPAppRestrict;